import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { DateTimeStr, toTimestamp } from '@mi-front/core';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

const goToStreamMessage = defineMessage({
  id: 'fragments.view.metadata.goToStream',
  defaultMessage: 'Ir al stream en el inicio del fragmento',
});

type FragmentGoToStreamFromStartActionProps = {
  stationSlug: string;
  fragmentFrom: DateTimeStr;
};

/**
 * Action button that opens logger stream at the fragment start timestamp.
 */
export function FragmentGoToStreamFromStartAction({
  stationSlug,
  fragmentFrom,
}: FragmentGoToStreamFromStartActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    cursor: toTimestamp(fragmentFrom),
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamFromStart({
      stationSlug,
      fragmentFrom,
    });
  };

  return (
    <Tooltip title={$t(goToStreamMessage)} placement="top">
      <IconButton
        component={RouterLink}
        to={loggerStreamUrl}
        onClick={handleClick}
        size="small"
        sx={{ color: 'text.secondary' }}
      >
        <LoggerIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
